import { environment } from './environments/environment'
import { environmentProd } from './environments/environment.prod'
import { IdentityConfiguration, RegionalSettings } from './models'

const identity = {} as IdentityConfiguration
const regionalSettings = {} as RegionalSettings

const config = {
  development: {
    environment: 'development',
    apis: {
      usersApi: 'https://users-api-test.listglobally.com/api/v2',
      contentsApi: 'https://contents-api-test.listglobally.com/api/v2',
      listingsApi: 'https://listings-api-test.listglobally.com/api/',
      communicationsApi:
        'https://communications-api-test.listglobally.com/api/',
      spamDetectionApi:
        'https://spam-detection-api-test.listglobally.com/api/v1/',
      backend: '/messages/api',
      accountsApi: 'https://accounts-api-test.listglobally.com/api/v2',
    },
    variables: environment,
    showCurrencySymbols: ['USD', 'EUR'],
  },
  production: {
    environment: 'production',
    apis: {
      usersApi: 'https://users-api.listglobally.com/api/v2',
      contentsApi: 'https://contents-api.listglobally.com/api/v2',
      listingsApi: 'https://listings-api.listglobally.com/api/',
      communicationsApi: 'https://communications-api.listglobally.com/api/',
      spamDetectionApi: 'https://spam-detection-api.listglobally.com/api/v1/',
      backend: '/messages/api',
      accountsApi: 'https://accounts-api.listglobally.com/api/v2',
    },
    variables: environmentProd,
    showCurrencySymbols: ['USD', 'EUR'],
  },
}

const getEnvConfig = () => {
  const env = process.env.NODE_ENV || 'development'
  return config[env as keyof typeof config]
}

const unlockContactDetailsUrls: Record<string, string> = {
  en: 'https://www.properstar.com/professionals/partners/how-to-get-contact-details',
  fr: 'https://www.properstar.fr/professionels/partenaires/comment-obtenir-les-coordonnees-de-contact',
  'fr-CH':
    'https://www.properstar.ch/professionels/partenaires/comment-obtenir-les-coordonnees-de-contact?c=fr-CH&dismissPortalSuggestion=true',
  de: 'https://www.properstar.de/fachleute/partner/so-erhalten-sie-kontaktdaten',
  'de-CH':
    'https://www.properstar.ch/fachleute/partner/so-erhalten-sie-kontaktdaten?c=de-CH&dismissPortalSuggestion=true',
  it: 'https://www.properstar.it/professionisti/partner/accedi-a-tutti-i-dettagli-dei-contatti',
  'it-CH':
    'https://www.properstar.ch/professionisti/partner/accedi-a-tutti-i-dettagli-dei-contatti',
  es: 'https://www.properstar.es/profesionales/partners/como-obtener-datos-de-contacto',
  pt: 'https://www.properstar.pt/profissionais/parceiros/como-obter-dados-de-contacto',
}

const apps = {
  ios: {
    protocol: 'listglobally.properstar',
    id: '1253028900',
  },
  android: {
    id: 'com.listglobally.properstar',
  },
}

export const apis = getEnvConfig().apis
export const vars = getEnvConfig().variables
export default {
  ...getEnvConfig(),
  ...{ identity },
  ...{ regionalSettings },
  ...{ unlockContactDetailsUrls },
  ...{ apps },
}
